import React, { useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { isEmpty, startCase } from "lodash";
import OutsideClickHandler from "react-outside-click-handler";
import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
  HomeTabData,
} from "../Pages/casino/ListHome";
import { t } from "i18next";
import ThemeContext from "../context/ThemeContext";
import FadeInWhenVisible from "./FadeInWhenVisible";
import Loader from "./Loader";
import { toast } from "react-toastify";

const MenuMerged = () => {
  const setLogoutShow = useContextSelector(
    AuthContext,
    (ctx) => ctx.setLogoutShow,
  );
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const setSidebarModal = useContextSelector(
    AuthContext,
    (ctx) => ctx.setSidebarModal,
  );
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const lang = useContextSelector(AuthContext, (ctx) => {
    return ctx.lang;
  });
  const changeLanguage = useContextSelector(AuthContext, (ctx) => {
    return ctx.changeLanguage;
  });
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );
  const theme = useContextSelector(ThemeContext, (ctx) => ctx.theme);
  const toggleTheme = useContextSelector(
    ThemeContext,
    (ctx) => ctx.toggleTheme,
  );
  const sidebarModal = useContextSelector(
    AuthContext,
    (ctx) => ctx.sidebarModal,
  );
  const setCasinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoBefore;
  });
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [show, setShow] = useState(false);

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (isEmpty(res?.platFormCode)) {
        toast.error(t("ComingSoon"));
      } else {
        if (!isEmpty(res?.gameid)) {
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType,
            isLobbyTrue: res?.isLobbyTrue,
          });
        }
      }
    } else {
      setCasinoBefore(true);
    }
  };
  return (
    sidebarModal && (
      <div className="cdk-overlay-container">
        <div className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
        <div
          className="cdk-global-overlay-wrapper"
          dir="ltr"
          style={{
            WebkitBoxPack: "center",
            WebkitJustifyContent: "center",
            msFlexPack: "center",
            justifyContent: "center",
            WebkitAlignItems: "center",
            WebkitBoxAlign: "center",
            msFlexAlign: "center",
            alignItems: "center",
          }}
        >
          <div
            id="cdk-overlay-4"
            className="cdk-overlay-pane dialog-panel"
            style={{ position: "static" }}
          >
            <mcd-dialog _nghost-serverapp-c2230345302>
              <div
                _ngcontent-serverapp-c2230345302
                className="popup"
                id="dialog-4"
              >
                <div
                  _ngcontent-serverapp-c2230345302
                  className="popup__header"
                />
                <div
                  _ngcontent-serverapp-c2230345302
                  className="popup__content"
                >
                  <div
                  style={{background:'transparent'}}
                    className={`menu ng-tns-c1658803631-19 ng-trigger ng-trigger-dialogTriggerAni ng-star-inserted${sidebarModal ? " active" : ""}`}
                  >
                    <div className="menu-first menu-first-new ng-tns-c1658803631-19">
                      <ul
                        className="home ng-tns-c1658803631-19 ng-star-inserted"
                        style={{}}
                      >
                        <li
                          data-category="home"
                          className="ng-tns-c1658803631-19"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-home.webp")',
                            }}
                          />
                          <Link className="ng-tns-c1658803631-19" to="/">
                            {t("Home")}
                          </Link>
                        </li>
                      </ul>

                      {/* Game category vendor list */}
                      <ul
                        className="vendor ng-tns-c1658803631-19 ng-star-inserted"
                        style={{}}
                      >
                        {/* HOT */}
                        <li
                          onClick={() =>
                            setActive(active === "hot" ? "" : "hot")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "hot" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-hotgame.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">{t("HOT")}</a>
                        </li>

                        {/* Sports */}
                        <li
                          onClick={() =>
                            setActive(active === "sports" ? "" : "sports")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "sports" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-sport.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Sports")}{" "}
                          </a>
                        </li>

                        {/* Casino */}
                        <li
                          onClick={() =>
                            setActive(active === "casino" ? "" : "casino")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "casino" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-casino.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Casino")}{" "}
                          </a>
                        </li>

                        {/* Slots */}
                        <li
                          onClick={() =>
                            setActive(active === "slots" ? "" : "slots")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "slots" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-slot.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Slots")}{" "}
                          </a>
                        </li>

                        {/* Crash */}
                        <li
                          onClick={() =>
                            setActive(active === "crash" ? "" : "crash")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "crash" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-crash.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Crash")}{" "}
                          </a>
                        </li>

                        {/* Table */}
                        <li
                          onClick={() =>
                            setActive(active === "table" ? "" : "table")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "table" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-table.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Table")}{" "}
                          </a>
                        </li>

                        {/* Fishing */}
                        <li
                          onClick={() =>
                            setActive(active === "fishing" ? "" : "fishing")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "fishing" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-fish.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Fishing")}{" "}
                          </a>
                        </li>

                        {/* Arcade */}
                        <li
                          onClick={() =>
                            setActive(active === "arcade" ? "" : "arcade")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "arcade" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-arcade.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Arcade")}{" "}
                          </a>
                        </li>

                        {/* Lottery */}
                        <li
                          onClick={() =>
                            setActive(active === "lottery" ? "" : "lottery")
                          }
                          className={`ng-tns-c1658803631-19 ng-star-inserted${active === "lottery" ? " active" : ""}`}
                          data-category-type-id={0}
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-lottery.webp")',
                            }}
                          />
                          <a className="ng-tns-c1658803631-19">
                            {" "}
                            {t("Lotto")}{" "}
                          </a>
                        </li>
                      </ul>

                      <ul
                        className="promotion-block ng-tns-c1658803631-19 ng-star-inserted"
                        style={{}}
                      >
                        <li
                          className="ng-tns-c1658803631-19 ng-star-inserted"
                          data-category="promotion"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-promotion.webp")',
                            }}
                          />
                          <Link
                            to="/promotions"
                            className="ng-tns-c1658803631-19 ng-star-inserted"
                          >
                            {t("PROMOITIONS")}
                          </Link>
                        </li>
                        {/* <li
                          className="ng-tns-c1658803631-19 ng-star-inserted"
                          data-category="promotion"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-winner-board.webp")',
                            }}
                          />
                          <Link
                            to="/winner-board"
                            className="ng-tns-c1658803631-19 ng-star-inserted"
                          >
                            {t("Winner Board")}
                          </Link>
                        </li>
                        <li
                          className="ng-tns-c1658803631-19 ng-star-inserted"
                          data-category="promotion"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-vip.png")',
                            }}
                          />
                          <Link
                            to="/vip"
                            className="ng-tns-c1658803631-19 ng-star-inserted"
                          >
                            {t("VIP")}
                          </Link>
                        </li>{" "} */}

                          <li
                          className="ng-tns-c1658803631-19 ng-star-inserted"
                          data-category="promotion"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-referral.webp")',
                            }}
                          />
                          <Link
                            to="/refrel"
                            className="ng-tns-c1658803631-19 ng-star-inserted"
                          >
                            {t("ReferBonus")}
                          </Link>
                        </li>


                        {/* <li
                          className="ng-tns-c1658803631-19 ng-star-inserted"
                          data-category="promotion"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-talk.webp")',
                            }}
                          />
                          <Link
                            to="/customer-support"
                            className="ng-tns-c1658803631-19 ng-star-inserted"
                          >
                            {t("CONTACTUS")}
                          </Link>
                        </li> */}
                      </ul>

                      <div
                        className="support-block ng-tns-c1658803631-19 ng-star-inserted"
                        onClick={() => navigate("/affiliate-link")}
                      >
                        <div
                          className="service ng-tns-c1658803631-19 ng-star-inserted"
                          data-service="affiliate"
                        >
                          <span
                            className="item-icon ng-tns-c1658803631-19"
                            style={{
                              backgroundImage:
                                'url("/assets/NewIcon/icon-affiliate.webp")',
                            }}
                          />
                          <p class="ng-tns-c1658803631-9 ng-star-inserted">
                            {" "}
                            {t("AffiliatesProgram")}{" "}
                          </p>
                        </div>
                      </div>

                      <div
                        className="language-select-area ng-tns-c1658803631-16 ng-star-inserted"
                        style={{}}
                      >
                        <div
                          onClick={(e) => changeLanguage("bn")}
                          className={`language-area ng-tns-c1658803631-16 ${lang == "bn" ? "active" : ""} ng-star-inserted`}
                          value={8}
                        >
                          <img
                            className="ng-tns-c1658803631-16"
                            alt="BD"
                            src="/assets/Other/BD.png"
                            loading="lazy"
                          />
                          <p className="ng-tns-c1658803631-16"> বাংলা </p>
                        </div>

                        <div
                          onClick={(e) => changeLanguage("en")}
                          className={`language-area ng-tns-c1658803631-16 ${lang == "en" ? "active" : ""} ng-star-inserted`}
                          value={1}
                        >
                          <img
                            className="ng-tns-c1658803631-16"
                            alt="GB"
                            src="/assets/NewIcon/GB.png"
                            loading="lazy"
                          />
                          <p className="ng-tns-c1658803631-16">{t("English")}</p>
                        </div>
                      </div>
                    </div>

                    <div className="menu-second ng-tns-c1658803631-19">
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${show ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {/* Deposit */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/wallet/deposit"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("Deposit")}
                              </p>
                            </Link>
                          </li>

                          {/* Withdraw */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/wallet/withdraw"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("Withdraw")}
                              </p>
                            </Link>
                          </li>

                          {/* Betting Records */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/betting-history"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("BettingRecords")}
                              </p>
                            </Link>
                          </li>

                          {/* Account Statement */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/account-statement"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("AccountStatement")}
                              </p>
                            </Link>
                          </li>

                          {/* Transaction Records */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/transaction-records"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("TransactionRecords")}
                              </p>
                            </Link>
                          </li>

                          {/* Personal Info */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/profile"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("PersonalInfo")}
                              </p>
                            </Link>
                          </li>

                          {/* Affiliate Link */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/affiliate-link"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("AffiliateLink")}
                              </p>
                            </Link>
                          </li>

                          {/* Reset Password */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <Link
                              _ngcontent-serverapp-c1589996670
                              to="/reset-password"
                              tabIndex={-1}
                            >
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("ResetPassword")}
                              </p>
                            </Link>
                          </li>

                          {/* Wallet balance + refresh */}
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <a _ngcontent-serverapp-c1589996670 tabIndex={-1}>
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                ৳{userCoins?.totalCoins}
                                <span
                                  onClick={() => amounutRefresh()}
                                  style={{ cursor: "pointer", marginLeft: 6 }}
                                >
                                  ↻
                                </span>
                              </p>
                            </a>
                          </li>
                        </mcd-side-game-layout>
                      </ul>

                      {/* Sports providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "hot" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {HomeTabData?.hot?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                              onClick={() => handel(res)}
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={"#"}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.src}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "sports" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <a
                              _ngcontent-serverapp-c1589996670
                              tabIndex={-1}
                              href="/sports-sky"
                              onClick={(e) => {
                                e.preventDefault();
                                window.location.href = "/sports-sky";
                              }}
                            >
                              <img
                                _ngcontent-serverapp-c1589996670
                                loading="lazy"
                                className="ng-star-inserted"
                                alt="icon-9w-cricket"
                                src="/assets/Platform/icon-9w-cricket.png"
                              />
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("Bhaijan9")}
                              </p>
                            </a>
                          </li>
                          <li
                            _ngcontent-serverapp-c1589996670
                            className="ng-star-inserted"
                          >
                            <a
                              _ngcontent-serverapp-c1589996670
                              tabIndex={-1}
                              href="/sports-velki"
                              onClick={(e) => {
                                e.preventDefault();
                                window.location.href = "/sports-velki";
                              }}
                            >
                              <img
                                _ngcontent-serverapp-c1589996670
                                loading="lazy"
                                className="ng-star-inserted"
                                alt="velki"
                                src="/assets/Icon/velki-favicon.ico"
                              />
                              <p
                                _ngcontent-serverapp-c1589996670
                                className="ng-star-inserted"
                              >
                                {t("Velkie")}
                              </p>
                            </a>
                          </li>
                        </mcd-side-game-layout>
                      </ul>

                      {/* Casino providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "casino" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filtercasion?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=casino&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      {/* Slots providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "slots" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filterslot?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=slots&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      {/* Crash providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "crash" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filtercrash?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=crash&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      {/* Table providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "table" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filtertable?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=table&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      {/* Fishing providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "fishing" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filterfishing?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=fishing&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      {/* Arcade providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "arcade" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filterarcade?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=arcade&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>

                      {/* Lottery providers */}
                      <ul
                        className={`menu-second-ul ng-tns-c1658803631-19 ng-star-inserted${active === "lottery" ? " active" : ""}`}
                        style={{}}
                      >
                        <mcd-side-game-layout
                          className="ng-tns-c1658803631-19"
                          _nghost-serverapp-c1589996670
                        >
                          {filterlotto?.map((res) => (
                            <li
                              key={res?.name}
                              _ngcontent-serverapp-c1589996670
                              className="ng-star-inserted"
                            >
                              <Link
                                _ngcontent-serverapp-c1589996670
                                to={`/casino?type=lottery&provider=${res?.name}`}
                                tabIndex={-1}
                              >
                                <img
                                  _ngcontent-serverapp-c1589996670
                                  loading="lazy"
                                  className="ng-star-inserted"
                                  alt={res?.name}
                                  src={res?.image}
                                />
                                <p
                                  _ngcontent-serverapp-c1589996670
                                  className="ng-star-inserted"
                                >
                                  {res?.name}
                                </p>
                              </Link>
                            </li>
                          ))}
                        </mcd-side-game-layout>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="menu-mask ng-trigger ng-trigger-popBgTriggerAni ng-tns-c1658803631-19 ng-star-inserted"
                    style={{
                      display: sidebarModal ? "block" : "none",
                      left: active
                        ? "calc(50.6666666667vw + 29.3333333333vw)"
                        : "50.6666666667vw",
                      transition: "left 0.5s",
                      zIndex: 200,
                    }}
                    onClick={() => {
                      setSidebarModal(false);
                      setShow(false);
                    }}
                  />
                </div>
              </div>
            </mcd-dialog>
          </div>
        </div>
      </div>
    )
  );
};

export default MenuMerged;
